import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnRS: CultureInfo = {
  name: 'en-RS',
  displayName: 'English (Serbia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-RS',
  parent: CultureInfoEn
};
